// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const EarningCard = () => (
  <Card elevation={0} className="!tw-rounded-xl !tw-border-0 !tw-bg-slate-50 tw-shadow-none dark:!tw-bg-slate-900">
    <CardContent>
      <Grid container direction="column">
        <Grid item>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Skeleton className="tw-rounded-lg" variant="rectangular" width={44} height={44} />
            </Grid>
            <Grid item>
              <Skeleton className="tw-rounded-lg" variant="rectangular" width={34} height={34} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Skeleton className="tw-rounded-lg" variant="rectangular" sx={{ my: 2 }} height={40} />
        </Grid>
        <Grid item>
          <Skeleton className="tw-rounded-lg" variant="rectangular" height={30} />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default EarningCard;
